import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginGetFile from 'filepond-plugin-get-file';
import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginMediaPreview from 'filepond-plugin-media-preview';
import FilePondPluginPdfPreview from 'filepond-plugin-pdf-preview';
import 'filepond/dist/filepond.min.css';

import React, { useEffect, useState } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';

import {
  Box,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { getHomeworks } from '../../../api/homework';
import { backendHOST } from '../../../client-config/client-config';
import HomeWorkItem from './HomeWorkItem';

registerPlugin(
  FilePondPluginMediaPreview,
  FilePondPluginPdfPreview,
  FilePondPluginGetFile,
  FilePondPluginImagePreview,
  FilePondPluginFileEncode,
);

const url = `${backendHOST}/api/upload/homework`;

export default function CreateHomeWork({
  id,
  title,
  description,
  diak_id,
  createad_at,
  status,
  deadline,
  jelenlet_id,
}) {
  const [files, setFiles] = useState([]);
  const [descr, setDescr] = useState(description || '');
  const [targy, setTitle] = useState(title || '');
  const [homeWorks, setHomeWorks] = useState([]);

  const serverSettings = {
    url,
    process: {
      headers: {
        'x-auth-token': localStorage.token,
        'Access-Control-Allow-Origin': '*',
      },
      onload: (response) => response.key,
      onerror: (error) => error.message,
      ondata: (formData) => {
        formData.append('homeWorkTitle', targy);
        formData.append('homeWorkDescr', descr);
        formData.append('jelenlet_id', jelenlet_id);
        formData.append('diak_id', diak_id);
        formData.append('createad_at', createad_at);

        return formData;
      },
    },
  };

  useEffect(() => {
    async function apiCall() {
      const apiResponse = await getHomeworks({ id_jelenlet: jelenlet_id });

      if (apiResponse) {
        setHomeWorks(apiResponse.data);
      }
    }

    apiCall();
  }, [jelenlet_id]);

  return (
    <React.Fragment>
      <Card
        elevation={1}
        sx={{
          borderRadius: 2,
          mb: 2,
        }}
      >
        <CardContent>
          <Stack spacing={2}>
            <Typography variant='h6' sx={{ fontWeight: 600 }}>
              Házi feladat rögzítése
            </Typography>

            <Box
              className='homework-item homerwork-create row'
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  md: '1fr 1fr',
                },
                gap: 2,
              }}
            >
              <Stack className='hw-column main' spacing={2}>
                <TextField
                  label='Feladat címe'
                  value={targy}
                  onChange={(event) => setTitle(event.target.value)}
                  fullWidth
                  size='small'
                />

                <TextField
                  label='Leírás'
                  value={descr}
                  onChange={(event) => setDescr(event.target.value)}
                  fullWidth
                  multiline
                  minRows={4}
                />
              </Stack>

              <Box className='hw-column file'>
                <FilePond
                  files={files}
                  onupdatefiles={setFiles}
                  allowMultiple={true}
                  allowDownloadByUrl={false}
                  allowImagePreview={true}
                  filePosterHeight={80}
                  styleButtonRemoveItemPosition='right'
                  maxFiles={5}
                  server={serverSettings}
                  name='files'
                  labelIdle='Húzd ide a fileokat vagy <span class="filepond--label-action">válaszd ki</span> a feltöltéshez!'
                />
              </Box>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      <Typography variant='subtitle1' sx={{ fontWeight: 600, mb: 1 }}>
        Eddig kiosztott feladatok:
      </Typography>

      {homeWorks &&
        homeWorks.map((hw) => {
          return (
            <HomeWorkItem
              key={hw.id}
              id={hw.id}
              file={hw.file}
              title={hw.homework_title}
              description={hw.homework_description}
              diak_id={hw.id_diak}
              createad_at={hw.created_at}
              status={hw.homework_status}
              deadline={hw.homework_deadline}
              jelenlet_id={hw.jelenlet_id}
            />
          );
        })}
    </React.Fragment>
  );
}
